// import req from 'superagent'
// import noCache from 'superagent-no-cache'
import $ from 'jquery'
import {error as errorFlash} from './flash-messages'
import config from './config'
import {assign} from 'lodash'

function request(method, url, body, endFunction, extraOptions, redirectOnUnauthorized = true) {
  const options = {
    url: `${config.baseUrl}${url}`,
    method: method,
    cache: false,
    processData: false,
    data: extraOptions.data || JSON.stringify(body),
    contentType: 'application/json',
    xhrFields: {
      withCredentials: true
    },
    // error: Function( jqXHR jqXHR, String textStatus, String errorThrown )
    error: function(xhr, textStatus, errorThrown) {
      const response = JSON.parse(xhr.responseText)
      if (errorThrown) {
        if (xhr.status === 401 && redirectOnUnauthorized) {
          window.location.href = `/login?return-to=${response.returnTo}`
          return
        }
        if (xhr.status === 403) {
          return forBiddenHandler(response)
        }

        if (xhr.status >= 400) {
          return errorFlash(response.message)
        }
      }
    }
  }

  assign(options, extraOptions)

  return $.ajax(options).done((res) => {
    return endFunction(res)
  })
}

export function get(url, endFunction, extraOptions = {}) {
  return request('GET', url, undefined, endFunction, extraOptions)
}

export function post(url, body, endFunction, extraOptions = {}, redirectOnUnauthorized = true) {
  return request('POST', url, body, endFunction, extraOptions, redirectOnUnauthorized)
}

export function patch(url, body, endFunction, extraOptions = {}) {
  return request('PATCH', url, body, endFunction, extraOptions)
}

export function del(url, body, endFunction, extraOptions = {}) {
  return request('DELETE', url, body, endFunction, extraOptions)
}

export function prependHostUrl(url) {
  return `${config.baseUrl}${url}`
}

export function forBiddenHandler(resp) {
  switch (resp.message) {
    case 'PASSWORD_CHANGE_REQUIRED':
      window.location.href = `/change-password?return-to=${resp.returnTo}`
      return
    case 'ADMINISTRATOR_ROLE_REQUIRED':
      window.location.href = '/admin-role-required'
      return
    case 'OUTGOING_REDIRECT':
      window.location = resp.returnTo
      return
    default:
      console.log('Unexpected message', resp.message)
  }
}



// WEBPACK FOOTER //
// ./src/api.js